import { settingsApi as settingsApiUrl, storeApi as storeApiUrl, mrWolfUserApi as mrWolfUserApiUrl } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const settingsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSettings: builder.query({
      query: () => ({
        url: settingsApiUrl(),
        method: 'POST',
        body: {
          data: {},
          method: 'read'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Settings'],
      keepUnusedDataFor: 86400,
    }),
    updateSettings: builder.mutation({
      query: (settingsData) => ({
        url: settingsApiUrl(),
        method: 'POST',
        body: {
          data: settingsData,
          method: 'update'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Settings'],
    }),
    updateCurrency: builder.mutation({
      query: (currency) => ({
        url: storeApiUrl(),
        method: 'POST',
        body: {
          data: {
            currency,
          },
          method: 'changeCurrency'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Settings', 'StoreCurrency'],
    }),
    fetchStoreCurrency: builder.query({
      query: (props = {}) => ({
        url: storeApiUrl(),
        method: 'POST',
        body: {
          data: {
            storeId: props?.storeId
          },
          method: 'getCurrency'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['StoreCurrency'],
      keepUnusedDataFor: 86400,
    }),
    updateExVat: builder.mutation({
      query: ({ exVat }) => ({
        url: mrWolfUserApiUrl(),
        method: 'POST',
        body: {
          data: {
            exVat
          },
          method: 'setBusinessExtension'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Settings'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchSettingsQuery,
  useUpdateSettingsMutation,
  useUpdateCurrencyMutation,
  useFetchStoreCurrencyQuery,
  useUpdateExVatMutation,
} = settingsApiSlice;
